import { connect } from 'react-redux';
import flatten from 'lodash/flatten';

import { commentsActions, RootState, Dispatch } from '../../api';

import TrackDetail, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/TrackDetail';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (
    {
      user,
      authentication,
      comments: {
        comments,
        tracksComments: tComments,
        commentsRepliesIds,
        isFetchingComments,
      },
    },
    { trackId },
  ) => {
    let data;
    let pagination;
    if (tComments[trackId]) {
      ({ data, pagination } = tComments[trackId]);
    }

    const totalComments = pagination?.total || 0;
    const trackComments = flatten(Object.values(data || {}));
    const commentsArray = trackComments.map((commentId: number) => {
      const comment = comments[commentId];
      const replies = commentsRepliesIds[commentId].map(
        (replyId) => comments[replyId],
      );

      return { ...comment, replies };
    });

    return {
      userId: user.id,
      comments: commentsArray,
      isFetchingComments,
      userIsLoggedIn: authentication.isLoggedIn,
      currentPage: pagination ? pagination.currentPage : 1,
      lastPageReached: pagination
        ? pagination.currentPage >= pagination.lastPage
        : false,
      totalComments,
    };
  },
  (dispatch: Dispatch, { trackId }) => ({
    fetchTrackComments: (page = 1, perPage = 20) =>
      dispatch(commentsActions.fetchComments(trackId, page, perPage)),
    sendTrackComment: (comment) =>
      dispatch(commentsActions.addComment(trackId, comment)),
    deleteComment: (commentId, parent) =>
      dispatch(
        commentsActions.deleteComment(commentId, { ...parent, trackId }),
      ),
  }),
)(TrackDetail);
